import React from "react";
import { Button, TextField, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Loader from "../Loader";
import _ from "lodash";
import { styles } from "./styles";
import RearrangableTable from "./RearrangableTable";

const TableWrapper = ({
  itemActionButtons,
  actionButtons,
  columns,
  onSearch,
  isLoading,
  tableRecords,
  reOrder,
  onSortEnd,
  classes,
  mutatingOrder
}) => {
  const debouncedOnSearch = _.debounce(onSearch, 200);


  return (
    <React.Fragment>
      <Paper classes={{ root: classes.searchBarContainer }}>
        <TextField
          classes={{ root: classes.searchField }}
          margin="dense"
          label="Search"
          variant="outlined"
          onChange={(event) => {
            debouncedOnSearch(event.target.value);
          }}
        />

      </Paper>
      {(actionButtons || []).map((_actionButton, i) => (
        <Button
          key={`_actionButton.tooltip-${i}`}
          classes={{ root: classes.actionButton }}
          variant="contained"
          onClick={_actionButton.onClick}
        >
          {_actionButton.content}
        </Button>
      ))}
        {isLoading || mutatingOrder?
        <div className="flex-row flex-space-around" style={{height:"100%"}}><Loader /></div>
         : <RearrangableTable
              itemActionButtons={itemActionButtons}
              data={tableRecords || []}
              onSortEnd={onSortEnd}
              columns={columns}
              axis={reOrder ? "y" : null}
              useDragHandle
              reOrder={reOrder}
        />}
    </React.Fragment>
  );
};
export default withStyles(styles)(TableWrapper);
